import { IModel } from "../../@types/models/model";
import coreFields from "../helpers/coreFields";

const Grading: IModel = {
  title: "Grading",
  apiPath: "pristupacnost/poi/grades",
  forms: {
    "default": {
      fields: ["category_id", "ocjena", "reason_id", "komentar"]
    },
  },
  listViews: {
    "default": {
      fields: ["id", "category_id", "reason_id", "ocjena", "komentar", "created_by", "created_on"],
      hidden: ["id",]
    },
    "history": {
      fields: ["id", "poi_id", "poi_naziv", "category_id", "reason_id", "ocjena", "komentar", "created_by", "created_on"],
      hidden: ["id", "poi_id"]
    }
  },
  fields: [
    coreFields.id,
    coreFields.created_by,
    coreFields.created_on,
    {
      title: "POI ID",
      source: "poi_id",
      ttoken: "pristupacnost:grading.poi_id",
      type: "text",
      sort: true,
      filter: true
    },
    {
      title: "POI naziv",
      source: "poi_naziv",
      ttoken: "pristupacnost:grading.poi_naziv",
      type: "text",
      sort: true,
      filter: true
    },
    {
      title: "Ocjena",
      source: "ocjena",
      ttoken: "pristupacnost:grading.ocjena",
      type: "numeric",
      sort: true,
      filter: true
    },
    {
      title: "Komentar",
      source: "komentar",
      ttoken: "pristupacnost:grading.komentar",
      type: "text",
      sort: true,
      filter: true
      //   validation: {
      //     required: true
      //   }
    },
    {
      title: "ID kategorije",
      source: "category_id",
      ttoken: "pristupacnost:grading.steps.ranjiva_skupina",
      type: "radio",
      items: {
        labels: ["pristupacnost:grading.rs1.title", "pristupacnost:grading.rs2.title", "pristupacnost:grading.rs3.title", "pristupacnost:grading.rs4.title", "pristupacnost:grading.rs5.title"],
        values: [1, 2, 3, 4, 5]
      },
      translate: true
    },

    {
      title: "ID razloga",
      source: "reason_id",
      ttoken: "pristupacnost:grading.element_pristupacnosti",
      type: "radio",
      items: {
        labels: [
          'pristupacnost:grading.rs1.ep1',
          'pristupacnost:grading.rs1.ep2',
          'pristupacnost:grading.rs1.ep3',
          'pristupacnost:grading.rs1.ep4',
          'pristupacnost:grading.rs1.ep5',
          'pristupacnost:grading.rs1.ep6',
          'pristupacnost:grading.rs2.ep1',
          'pristupacnost:grading.rs2.ep2',
          'pristupacnost:grading.rs2.ep3',
          'pristupacnost:grading.rs2.ep4',
          'pristupacnost:grading.rs3.ep1',
          'pristupacnost:grading.rs3.ep2',
          'pristupacnost:grading.rs3.ep3',
          'pristupacnost:grading.rs4.ep1',
          'pristupacnost:grading.rs4.ep2',
          'pristupacnost:grading.rs4.ep3',
          'pristupacnost:grading.rs4.ep4',
          'pristupacnost:grading.rs5.ep1',
          'pristupacnost:grading.rs5.ep2',
          'pristupacnost:grading.rs5.ep3',
          'pristupacnost:grading.rs5.ep4'
        ],
        values: [
          11,
          12,
          13,
          14,
          15,
          16,
          21,
          22,
          23,
          24,
          31,
          32,
          33,
          41,
          42,
          43,
          44,
          51,
          52,
          53,
          54
        ]
      }
    },
  ]
}

export default Grading;

